import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, Server, Trophy } from 'lucide-react';
import { useServerStatus } from '../../hooks/useServerStatus';
import { links } from '../../constants/links';

export function ServerStats() {
  const { t } = useTranslation();
  const serverStatus = useServerStatus(links.serverIp);

  const stats = [
    { 
      icon: <Users className="h-8 w-8" />, 
      label: t('stats.onlinePlayers'), 
      value: serverStatus.online ? serverStatus.players.online.toString() : t('stats.loading'),
      loading: !serverStatus.online
    },
    { 
      icon: <Server className="h-8 w-8" />, 
      label: t('stats.serverVersion'), 
      value: serverStatus.version || t('stats.loading'),
      loading: !serverStatus.version
    },
    { 
      icon: <Trophy className="h-8 w-8" />, 
      label: t('stats.registeredPlayers'), 
      value: '76,000+' 
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-gray-800/90 backdrop-blur-sm p-6 rounded-lg shadow-xl border border-gray-700"
        >
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-[#f8cb08]/10 rounded-lg text-[#f8cb08]">
              {stat.icon}
            </div>
            <div>
              <p className="text-gray-400 text-sm">{stat.label}</p>
              <p className={`text-2xl font-bold ${stat.loading ? 'animate-pulse text-gray-500' : ''}`}>
                {stat.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}